export const GET_CONTEXT_INSIGHTS = 'get-context-insights';
export const GET_CONTEXT_INSIGHT_PERIODS = 'get-context-insight-periods';
